__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "assembler";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@adobe/aem-react-editable-components", "2.0.4", () => (() => (__webpack_require__(3792))), 1);
			register("@adobe/aem-spa-page-model-manager", "1.5.0", () => (() => (__webpack_require__(9570))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(5587))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(1479))), 1);
			register("@module-federation/utilities", "3.1.67", () => (() => (__webpack_require__(6636))), 1);
			register("@quantum/tools/context", "2.9.0", () => (() => (__webpack_require__(6389))), 1);
			register("@quantum/tools/dataSharing", "2.9.0", () => (() => (__webpack_require__(4926))), 1);
			register("@quantum/tools/redux", "2.9.0", () => (() => (__webpack_require__(4388))), 1);
			register("@reduxjs/toolkit", "2.12.0", () => (() => (__webpack_require__(9879))), 1);
			register("react-dom/client", "18.3.1", () => (() => (__webpack_require__(5338))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(9733))), 1);
			register("react/jsx-runtime", "18.3.1", () => (() => (__webpack_require__(4848))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};